/* Avrenne Leadlight — theme scripts (no dependencies) */
(function () {
  'use strict';

  var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || { routes: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function withDelimiters(num, precision, thousands, decimal) {
      var parts = (num / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function toast(message) {
    var el = qs('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ---------------- drawers ---------------- */
  var lastFocus = null;
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('no-scroll');
    var focusable = qs('[data-close-drawer], button, a, input', qs('.drawer__panel', drawer));
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 360);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer')); return; }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    closeMega();
    var lb = qs('.lightbox'); if (lb) lb.remove();
  });

  /* ---------------- mega menu ---------------- */
  function closeMega() {
    qsa('[data-mega-toggle][aria-expanded="true"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  }
  qsa('[data-mega-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var item = btn.closest('[data-mega-item]');
    var timer;
    function open() { closeMega(); btn.setAttribute('aria-expanded', 'true'); if (panel) panel.hidden = false; }
    var canHover = window.matchMedia('(hover: hover)').matches;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-expanded') === 'true' && !canHover) closeMega(); else open();
    });
    if (item && canHover) {
      item.addEventListener('mouseenter', function () { clearTimeout(timer); open(); });
      item.addEventListener('mouseleave', function () { timer = setTimeout(closeMega, 180); });
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mega-item]')) closeMega();
  });

  /* ---------------- announcement rotation ---------------- */
  qsa('[data-announcement]').forEach(function (bar) {
    var msgs = qsa('.announcement__msg', bar);
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0, paused = false;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------------- search overlay + predictive ---------------- */
  var overlay = qs('#SearchOverlay');
  function openSearch() {
    if (!overlay) return;
    overlay.hidden = false;
    document.documentElement.classList.add('no-scroll');
    var input = qs('[data-predictive-input]', overlay);
    if (input) setTimeout(function () { input.focus(); }, 30);
  }
  function closeSearch() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.documentElement.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('[data-close-search]')) { e.preventDefault(); closeSearch(); return; }
    if (overlay && e.target === overlay) closeSearch();
  });
  if (overlay) {
    var input = qs('[data-predictive-input]', overlay);
    var results = qs('[data-predictive-results]', overlay);
    var debounce;
    input && input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        var url = (theme.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<p class="muted">No products match “' + escapeHtml(q) + '”. Try another word, like “cat” or “Christmas”.</p>';
            return;
          }
          results.innerHTML = '<ul class="predictive__list">' + products.map(function (p) {
            var img = p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span></span>';
            var price = p.price ? formatMoney(Math.round(parseFloat(String(p.price).replace(/[^0-9.]/g, '')) * 100)) : '';
            return '<li><a class="predictive__item" href="' + p.url + '">' + img +
              '<span><span class="predictive__title">' + escapeHtml(p.title) + '</span><span class="predictive__price">' + price + '</span></span></a></li>';
          }).join('') + '</ul><p style="margin-top:14px"><a class="text-link" href="' + theme.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">See all results</a></p>';
        }).catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
  }

  /* ---------------- cart ---------------- */
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
  }
  function renderDrawer(html) {
    var drawer = qs('#CartDrawer');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('#CartDrawer', doc);
    if (fresh) {
      qs('.drawer__panel', drawer).innerHTML = qs('.drawer__panel', fresh).innerHTML;
      updateCartCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
    }
  }
  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !qs('#CartDrawer')) return;
    e.preventDefault();
    var btn = qs('[type="submit"]', form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch((theme.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || res.json.message || 'This item could not be added. Please try again.'); return; }
        if (res.json.sections) renderDrawer(res.json.sections['cart-drawer']);
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  });

  document.addEventListener('click', function (e) {
    var change = e.target.closest('[data-line-change]');
    if (!change || !change.closest('#CartDrawer')) return;
    e.preventDefault();
    var line = parseInt(change.getAttribute('data-line'), 10);
    var qty = parseInt(change.getAttribute('data-qty'), 10);
    var panel = change.closest('.drawer__panel');
    if (panel) panel.style.opacity = '.6';
    cartRequest((theme.routes.cartChange || '/cart/change') + '.js', { line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || 'Could not update the cart.'); return; }
        renderDrawer(res.json.sections && res.json.sections['cart-drawer']);
      })
      .finally(function () { if (panel) panel.style.opacity = ''; });
  });

  // cart page: auto-update quantities
  qsa('[data-cart-form] [data-qty-input]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form.requestSubmit ? inp.form.requestSubmit(qs('[name="update"]', inp.form)) : inp.form.submit(); });
  });

  /* ---------------- quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = qs('input', wrap);
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = Math.max(parseInt(input.min || '0', 10), val + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- product page ---------------- */
  qsa('[data-product]').forEach(function (root) {
    var jsonEl = qs('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = qs('form[data-product-form]', root);
    var idInput = form ? qs('input[name="id"]', form) : null;
    var priceEl = qs('[data-price-wrap]', root);
    var btn = form ? qs('[data-add-button]', form) : null;
    var btnLabel = btn ? qs('[data-add-label]', btn) : null;
    var stickyBtn = qs('[data-sticky-add]');
    var stickyPrice = qs('[data-sticky-price]');
    var track = qs('[data-gallery-track]', root);

    function selectedOptions() {
      return product.options.map(function (name, i) {
        var checked = qs('[data-option-index="' + i + '"]:checked', root);
        var select = qs('select[data-option-index="' + i + '"]', root);
        if (checked) return checked.value;
        if (select) return select.value;
        return null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    function priceHtml(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      return '<div class="price price--lg' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(v.price) + '</span>' +
        (sale ? '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + formatMoney(v.compare_at_price) + '</s>' : '') + '</div>';
    }
    function update() {
      var opts = selectedOptions();
      qsa('[data-option-value-label]', root).forEach(function (lbl) {
        var i = parseInt(lbl.getAttribute('data-option-value-label'), 10);
        lbl.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      if (!v) {
        if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'Unavailable'; }
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = priceHtml(v);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (btn) {
        btn.disabled = !v.available;
        if (btnLabel) btnLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.featured_media && track) {
        var slide = qs('[data-media-id="' + v.featured_media.id + '"]', track);
        if (slide) goToSlide(slide);
      }
    }
    qsa('[data-option-index]', root).forEach(function (el) { el.addEventListener('change', update); });

    // gallery
    function goToSlide(slide) {
      if (!track || !slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (track) {
      var slides = qsa('[data-media-id]', track);
      var thumbs = qsa('[data-thumb]', root);
      var dots = qsa('[data-dot]', root);
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var slide = qs('[data-media-id="' + t.getAttribute('data-thumb') + '"]', track);
          goToSlide(slide);
        });
      });
      var setActive = function () {
        var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(setActive); }, { passive: true });
      setActive();
      qsa('[data-zoom]', root).forEach(function (z) {
        z.addEventListener('click', function () {
          var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          var img = qs('img', slides[idx]);
          if (!img) return;
          var src = img.currentSrc || img.src;
          var lb = document.createElement('div');
          lb.className = 'lightbox';
          lb.setAttribute('role', 'dialog');
          lb.setAttribute('aria-label', 'Zoomed image');
          lb.innerHTML = '<img src="' + src.replace(/width=\d+/, 'width=1800') + '" alt="">' +
            '<button class="icon-btn" type="button" aria-label="Close">' + qs('[data-close-icon]', root).innerHTML + '</button>';
          lb.addEventListener('click', function () { lb.remove(); });
          document.body.appendChild(lb);
          qs('button', lb).focus();
        });
      });
    }

    // sticky add to cart (mobile)
    var sticky = qs('[data-sticky-buy]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      });
      io.observe(btn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
      });
    }
  });

  /* ---------------- product tabs (section rendering) ---------------- */
  qsa('[data-tabs]').forEach(function (wrap) {
    var tabs = qsa('[role="tab"]', wrap);
    var panel = qs('[data-tab-panel]', wrap);
    var more = qs('[data-tab-more]', wrap);
    var cache = {};
    function load(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
      if (more) { more.href = tab.getAttribute('data-collection-url'); more.textContent = tab.getAttribute('data-more-label'); }
      var inlineId = tab.getAttribute('data-inline');
      var inline = inlineId ? document.getElementById(inlineId) : null;
      if (inline) { panel.innerHTML = inline.innerHTML; return; }
      var url = tab.getAttribute('data-fetch-url');
      if (!url) return;
      if (cache[url]) { panel.innerHTML = cache[url]; return; }
      panel.setAttribute('aria-busy', 'true');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = qs('[data-fetched-grid]', doc);
        cache[url] = grid ? grid.outerHTML : '<p class="empty-note">No products in this category yet.</p>';
        if (tab.getAttribute('aria-selected') === 'true') panel.innerHTML = cache[url];
      }).catch(function () {
        panel.innerHTML = '<p class="empty-note">Products could not load. <a class="text-link" href="' + tab.getAttribute('data-collection-url') + '">Open the category</a></p>';
      }).finally(function () { panel.removeAttribute('aria-busy'); });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { load(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus(); load(next);
      });
    });
    if (tabs[0]) load(tabs[0]);
  });

  /* ---------------- collection: sort + filters ---------------- */
  qsa('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  qsa('[data-open-filters]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById('Filters'); if (!panel) return;
      var opened = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(opened));
      if (opened) { var first = panel.querySelector('summary, button'); if (first) first.focus({preventScroll:true}); }
    });
  });
  qsa('[data-close-filters]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById('Filters'); if (!panel) return;
      panel.classList.remove('is-open');
      var opener = document.querySelector('[data-open-filters]');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var panel = document.getElementById('Filters');
      if (panel && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        var opener = document.querySelector('[data-open-filters]');
        if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      }
    }
  });

  /* ---------------- product recommendations ---------------- */
  qsa('[data-recs]').forEach(function (wrap) {
    if (wrap.children.length) return;
    var url = wrap.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = qs('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) wrap.innerHTML = fresh.innerHTML; else wrap.remove();
    }).catch(function () { wrap.remove(); });
  });

  /* ---------------- order tracking ---------------- */
  qsa('form[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = (qs('input', form).value || '').replace(/\s+/g, '');
      if (!val) { toast('Enter the tracking number from your shipping email.'); return; }
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(val), '_blank', 'noopener');
    });
  });
})();
